import axiosWithAuth from "lib/utils/axiosWithAuth";
import { HomeWorkDataType } from "types/document";

export default async function createHomeWork(
  title: string,
  module: string
): Promise<HomeWorkDataType> {
  const resp = await axiosWithAuth.post(
    `${process.env.REACT_APP_NOORIOO_API}/documents/new`,
    {
      title,
      module,
    }
  );

  if (!resp.data) {
    throw new Error("Some error occured");
  }
  if (resp.data.error) {
    throw new Error(resp.data.error);
  }

  return resp.data;
}
